import {
	Toast
} from "vant";
import router from "../../router/index";
// 全民营销 第三方产品弹框绑定推荐人
export const referencePop = {
	data() {
		return {
			bindShow: false, // 全民营销绑定关系
			referencePopItem: {}
		};
	},
	methods: {
		// 全民营销 判断绑定关系
		userBind(item) {
			let dkId = localStorage.getItem("dkId");
			if (!dkId) {
				// 未登录
				if (item.productNature == 1) {
					localStorage.setItem("jumpLogin", window.location.href);
					router.replace({
						path: "/login"
					});
					return;
				} else {
					//自营产品
					localStorage.setItem("shisuanBack", window.location.href);
					this.$router.replace({
						path: "/financingDetail",
						query: {
							productNo: item.productNo
						}
					});
					return;
				}
			}
			this.$common.getData(
				"/app/market/getReferencePop", {
					productNo: item.productNo,
					dkId: localStorage.getItem("dkId")
				},
				res => {
					if (res == true) {
						this.bindShow = true;
						this.referencePopItem = item;
						this.$nextTick(() => {
							this.$refs.inputRef.setFocus();
						});
					} else {
						this.productClick(item);
					}
				},
				error => {
					// Toast.fail(error);
				}
			);
		},
		// 填写推荐人姓名
		bindUserClick(value) {
			let data = {
				referenceName: value,
				dkId: localStorage.getItem("dkId"),
				productNo: this.referencePopItem.productNo
			};
			// 填写推荐人姓名
			this.$common.infoSubmit(
				"/app/market/confirmReferencePop",
				data,
				res => {
					this.productClick(this.item);
				},
				error => {
					Toast.fail(error);
				}
			);
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/market/referencePop.js